import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ar from './locales/ar.json';

const STORAGE_KEY = 'adminDashboardLang';

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ar: { translation: ar } },
  lng: typeof window !== 'undefined' ? (localStorage.getItem(STORAGE_KEY) || 'en') : 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'ar'],
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng: string) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.body.classList.toggle('rtl', lng === 'ar');
  document.body.classList.toggle('ltr', lng !== 'ar');
  if (typeof window !== 'undefined') localStorage.setItem(STORAGE_KEY, lng);
});

// Set initial dir/lang on load
if (typeof document !== 'undefined') {
  const lng = i18n.language || 'en';
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.body.classList.toggle('rtl', lng === 'ar');
  document.body.classList.toggle('ltr', lng !== 'ar');
}

export default i18n;
